import { render, staticRenderFns } from "./ListSessaoView.vue?vue&type=template&id=b167943a&"
import script from "./ListSessaoView.vue?vue&type=script&lang=js&"
export * from "./ListSessaoView.vue?vue&type=script&lang=js&"
import style0 from "./ListSessaoView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports